import { apiSlice } from "./apiSlice";

export const camSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({

        getAllICAM: builder.query({
            query: (params) => ({
                url: `CAM`,
                params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["CAMTracker"],
        }),

        createCAM: builder.mutation({
            query: ({ body }) => ({
                url: `CAM`,
                method: "POST",
                body,
            }),
            invalidatesTags: ["CAMTracker"],
        }),

        updateCAM: builder.mutation({
            query: ({ body }) => ({
                url: `CAM`,
                method: "PUT",
                body,
            }),
            invalidatesTags: ["CAMTracker"],
        }),
        getExportCam: builder.query({
            query: (params) => ({
                url: `CAM`,
                params,
            }),
            keepUnusedDataFor: 0,
        }),

    }),
});

export const { useGetAllICAMQuery, useLazyGetAllICAMQuery, useCreateCAMMutation, useUpdateCAMMutation, useLazyGetExportCamQuery } = camSlice;